import { createReducer } from '@reduxjs/toolkit';

import deleteRole from '../../thunks/roles/deleteRole';

const initialState = {
  loading: false,
  error: null,
  deleted: false
};

const deleteRolesReducer = createReducer(initialState, {
  [deleteRole.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
    deleted: false
  }),
  [deleteRole.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    deleted: payload
  }),
  [deleteRole.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    deleted: false
  }),
});

export default deleteRolesReducer;
